import React from 'react';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';
import {List} from 'immutable';
import './MiniScore.styl';
import AnswerBubble from 'components/pure/utils/AnswerBubble';
import {QUESTION_TYPE_TYPE} from 'records/CoachingReviewTypeQuestion';
import {answersFor, scorecardTypes} from 'records/Scorecard';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {makePrompt} from 'components/coaching/SubmitContentDetailScore';
import User from 'records/User';
import {ReactComponent as UTurnIcon} from 'images/icon/u-turn.svg';
import {browserHistory} from 'react-router';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';
import {QuestionIdentifier} from 'components/calls/components/sidebar/listening-assistant/QuestionIdentifier';

interface Props {
  onExpand: (qid: QuestionIdentifier) => void;
  scores: List<CoachingContentDetailScore>;
  scoringSchemeMap: any; // TODO
  questionMap: Map<any, any>; // TODO
  recipient: User;
}

export const MiniScore: React.FC<Props> = ({
  scores,
  onExpand,
  scoringSchemeMap,
  questionMap,
  recipient,
}) => {
  return (
    <div className={'listening-assistant-mini-scores'}>
      {scores.map((s, i) => {
        const scoringScheme = s.scorecardQuestionId
          ? scoringSchemeMap.get(s.scorecardQuestionId)
          : QUESTION_TYPE_TYPE.ContentDetail;

        if (!scoringScheme) {
          return null;
        }

        const answerButtons = answersFor(scoringScheme);
        const answerToDisplay = answerButtons.find(ab => ab.value === s.score);
        const question = questionMap.get(s.scorecardQuestionId);
        const prompt = makePrompt(question, s, s.contentDetail.skillName, recipient);

        const onClick = e => {
          e.preventDefault();

          onExpand({
            scorecardQuestionId: s.scorecardQuestionId,
            contentDetailId: s.contentDetailId,
          });
        };

        return (
          <div key={i}>
            <GenericTooltip
              tooltip={prompt}
              positionLeft
              delay={TOOLTIP_DELAY}
              hoverBehavior
              closeImmediately>
              <div onClick={onClick}>
                <AnswerBubble
                  isSelected
                  answer={s.score}
                  button={
                    // we may not (rightfully so, although we dont handle this well)
                    // have an answer to display if it's not a scorecard type. but we do need a placeholder.
                    // so use the "placeholder" we have - N/A
                    answerToDisplay || scorecardTypes.YesNo.answers.find(v => v.value === null)
                  }
                  extraWide={false}
                  darkenOnHover
                />
              </div>
            </GenericTooltip>
          </div>
        );
      })}
      <div className={'bottom pointer'} onClick={browserHistory.goBack}>
        <UTurnIcon />
      </div>
    </div>
  );
};
